import UserSessionFunctions from "@/functions/userSessionFunctions";
import UnlockMoreService from "@/services/unlockMoreService";
import store from "@/store";
import DepService from "@/services/depService";

export async function userAuthenticate(to, from, next) {
    const urlParams = new URLSearchParams(window.location.search);
    const encryptedMsisdn = urlParams.get('e-msisdn');

    if (to.path === '/login/request-otp') return next();
    if (to.path === '/login/submit-otp') return next();
    if (to.path === '/terms-and-conditions') return next();
    if (to.path === '/how-it-works') return next();

    if (to.path === '/') {
        if (encryptedMsisdn) {
            const decryptResponse = await DepService.decryptMsisdn(encryptedMsisdn);
            const rawMsisdn = decryptResponse.data.rawMsisdn || decryptResponse.data;
            const user = await UnlockMoreService.getUser(rawMsisdn);
            if (!user.data.msisdn) user.data.msisdn = rawMsisdn;
            await UnlockMoreService.trackUserLogin(rawMsisdn);
            UserSessionFunctions.setUserSesssionHasLoggedIn(true);
            UserSessionFunctions.setUserSesssionMsisdn(user.data.msisdn);
            store.commit('setUser', user.data);
            return next('/game');
        } else {
            return next('/login/request-otp');
        }
    }

    if (UserSessionFunctions.getUserSesssionHasLoggedIn()) {
        let user = await UnlockMoreService.getUser(UserSessionFunctions.getUserSesssionMsisdn());
        store.commit('setUser', user.data);
        return next();
    } else {
        return next('/login/request-otp');
    }
}